import React from 'react'

import { useNavigate }  from 'react-router-dom'

import landingFooterBg from '@kolayyolla/common/images/landingFooterBg.png'

import { ArrowForwardIosOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${landingFooterBg})`,
    width: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: 350,
    overflow: 'hidden',
    willChange: 'transform, opacity, filter',
    backfaceVisibility: 'hidden',
    backgroundRepeat: 'no-repeat',
    zIndex: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  innerContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center'

  },
  header: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 40,
    fontFamily: 'Source Sans Pro, sans-serif',
    filter: 'drop-shadow(5px 5px 5px rgba(0,0,0,0.1))'
  },
  button: {
    width: 200,
    marginTop: 32,
    boxShadow: 'none',
    fontWeight: 'bold',
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText
  }
}))

export default function LandingFooter () {
  const classes  = useStyles()
  const navigate = useNavigate()

  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
          <Typography variant="h3" align="center" className={classes.header}>Her siparişinizde <br />kazanmaya hazır mısınız?</Typography>
          <Button variant='contained' endIcon={<ArrowForwardIosOutlined />} className={classes.button} onClick={() => navigate('/login')} >Sipariş Ver</Button>
      </div>
    </div>
  )
}
